<template>
  <div class="betting-record">
    <el-form ref="form" :model="form" size="mini" label-position="left">
      <el-form-item label="返水金额:">
        <el-col :span="2" class="positioning">
          <el-input v-model="form.moneyMin" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="0"></el-input>
          <i>￥</i>
        </el-col>
        <el-col :span="1">至</el-col>
        <el-col :span="2" class="input-left positioning">
          <el-input v-model="form.moneyMax" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="0"></el-input>
          <i>￥</i>
        </el-col>
      </el-form-item>

      <el-form-item label="时间筛选:" class="input-icon-right">
        <el-col :span="3" class="time-icon">
          <el-date-picker
            type="date"
            placeholder="年/月/日"
            v-model="form.startTime"
            :picker-options="startDatePicker"
            :editable="false"
            :clearable="false"
            style="width: 100%;cursor:pointer;"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="1">至</el-col>
        <el-col :span="3" class="time-icon input-left">
          <el-date-picker
            type="date"
            placeholder="年/月/日"
            v-model="form.endTime"
            :picker-options="endDatePicker"
            :editable="false"
            :clearable="false"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
          <el-button @click="getListData()" class="btn" style="margin-left:12.5%;">查询</el-button>
          <el-button @click="reset()" class="btn">重置</el-button>
      </el-form-item>

      <p class="remind">每条返水的数据将有一定时间的延迟，仅供参考使用</p>
    </el-form>
    <!-- <div v-show="!nothingShow" class="table-conent">
      <el-table :data="tableData" border size="medium" max-height="300" ref="multipleTable">
        <el-table-column prop="createdAt" label="时间" align="center" width="200"></el-table-column>
        <el-table-column prop="vendorName" label="游戏平台" align="center" width="200"></el-table-column>
        <el-table-column prop="gameName" label="游戏名称" align="center" width="200"></el-table-column>
        <el-table-column prop="effectiveBet" label="流水" align="center" width="200"></el-table-column>
        <el-table-column prop="rebateAmount" label="返水" align="center" width="200"></el-table-column>
      </el-table>
    </div>
    <div slot="combined"></div> -->
    <div>
      <el-table :data="tableData" class="myTable" height="650">
        <el-table-column prop="createdAt" label="时间" align="center" width="200"></el-table-column>
        <el-table-column prop="vendorName" label="游戏平台" align="center" width="200"></el-table-column>
        <el-table-column prop="gameName" label="游戏名称" align="center" width="200"></el-table-column>
        <el-table-column prop="effectiveBet" label="流水" align="center" width="200"></el-table-column>
        <el-table-column prop="rebateAmount" label="返水" align="center" width="200"></el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :total="form.total"
        :page-size="15"
        @current-change="handleCurrentChange"
        :current-page.sync="form.currentPage"
        style="float: right;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startDatePicker: this.beginDate(),
      endDatePicker: this.endDate(),
      form: {
        moneyMin: "",
        moneyMax: "",
        startTime: "",
        endTime: "",
        total:1,
        pageSize: 10,
        currentPage: 1,
        region: "",
        memberId: this.$common.getUser()?this.$common.getUser().user_id : ""
      },
      gameList: [],
      tableData: [],
      type:'',
      betNo:'',
    };
  },
  methods: {
    beginDate() {
      let that = this;
      return {
        disabledDate(time) {
          if (that.form.endTime) {
            return (
              time.getTime() > that.form.endTime || time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        }
      };
    },
    endDate() {
      let that = this;
      return {
        disabledDate(time) {
          if (that.form.startTime) {
            return (
              time.getTime() < that.form.startTime ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        }
      };
    },
    onCopyResult(type) {
      if (type === "success") {
        this.$message({
          message: "复制成功",
          type: "success"
        });
      } else {
        this.$message.error("复制失败");
      }
    },
    reset() {
      this.form.moneyMin = "";
      this.form.moneyMax = "";
      this.form.startTime = "";
      this.form.endTime = "";
    },
    conversionTime(timeStamp) {
      if (timeStamp > 0) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        // return y + "-" + m + "-" + d;
      } else {
        return "";
      }
    },
    According(type, betNo) {
      this.type = type; //0 查询待领取返水  1 查询批次返水 详情
      if(betNo){
        this.betNo = betNo; //查询批次返水   单号
      }
      
      this.form.moneyMin = "";
      this.form.moneyMax = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.form.memberId = this.$common.getUser()? this.$common.getUser().user_id:"";
      this.tableData = [];
      this.form.total = 0;
      this.getListData(1);
    },
    handleCurrentChange(index) {
      this.form.currentPage = index;
      this.getListData(index);
    },
    format(time, format) {
      var t = new Date(time);
      var tf = function(i) {
        return (i < 10 ? "0" : "") + i;
      };
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
        switch (a) {
          case "yyyy":
            console.log(a);
            return tf(t.getFullYear());
            break;
          case "MM":
            return tf(t.getMonth() + 1);
            break;
          case "mm":
            return tf(t.getMinutes());
            break;
          case "dd":
            return tf(t.getDate());
            break;
          case "HH":
            return tf(t.getHours());
            break;
          case "ss":
            return tf(t.getSeconds());
            break;
        }
      });
    },
    // 查询列表数据
    getListData(val = 1) {
      if (this.type == 0) {
        //待领取返水
        this.getRebateAmountDetail(val);
      } else {
        //查询批次返水详情
        this.getDetailByBetNo();
      }
    },
    getRebateAmountDetail(val) {
      this.form.currentPage = val - 0;

      let form = JSON.parse(JSON.stringify(this.form));
      form.startTime?(form.startTime = this.format(form.startTime, "yyyy-MM-dd HH:mm:ss")):(form.startTime = "");
      form.endTime?(form.endTime = this.format(form.endTime, "yyyy-MM-dd 23:59:59")):(form.endTime = "");

      //待领取 status = 0
      this.$set(form, "currentPage", val);
      this.$set(form, "pageSize", 10);
      this.$set(form, "status", 0);
      this.$set(form, "delFlag", 0);

      this.$http.post(this.$api.getRebateAmountDetail, form, true).then(res => {
        console.log(res.data, "待领取返水，，，，，，，，，，，，，，");
        if (res && res.data && res.data.list.length > 0) {
          res.data.list.map(item => {
            item.createdAt = this.conversionTime(item.createdAt);
          });

          if (res.data.total > 10) {
            this.form.total = res.data.total;
          } else {
            this.form.total = 0;
          }
          res.data.list.forEach(item => {
            item.rebateAmount = this.$common.setNumFixed(item.rebateAmount, 2);
            item.effectiveBet = this.$common.setNumFixed(item.effectiveBet, 2);
          });
          this.tableData = res.data.list;
          this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        } else {
          this.tableData = [];
          this.form.total = 0;
          if (res.code !== 0) {
            this.$message.error(res.msg);
          }
        }
      });
    },
    getDetailByBetNo() {
      let form = JSON.parse(JSON.stringify(this.form));
      form.startTime?(form.startTime = this.format(form.startTime, "yyyy-MM-dd HH:mm:ss")):(form.startTime = "");
      form.endTime?(form.endTime = this.format(form.endTime, "yyyy-MM-dd 23:59:59")):(form.endTime = "");

      //批次返水 betNo 单号
      this.$set(form, "betNo", this.betNo);

      this.$http.post(this.$api.getDetailByBetNo, form, true).then(res => {
        if (res && res.data && res.data.length > 0) {
          res.data.map(item => {
            item.createdAt = this.conversionTime(item.createdAt);
          });
          this.tableData = res.data;
          this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        } else {
          this.tableData = [];
          if (res.code !== 0) {
            this.$message.error(res.msg);
          }
        }
      });
    }
  }
};
</script>

<style lang="less">
.positioning {
  position: relative;
  i {
    // height: 100%;
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 0.16rem;
    color: #333333;
  }
}
.betting-record {
  body .el-table th.gutter {
    display: table-cell !important;
  }
  .el-table__header-wrapper {
    font-size: 0.16rem;
  }
  // .el-table__header {
  //   width: auto !important;
  // }
  // .el-table__body {
  // 	width: auto !important;
  // }
  .el-table {
    // height: 3rem !important;
    font-size: 0.14rem;
    .copybutton {
      border: none;
      color: #32a0ed;
      background: none;
      padding: 0 5px;
      font-size: 0.14rem !important;
      padding-top: 0.02rem;
    }
    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 0.6rem;
      font-size: 0.14rem !important;
    }
  }
  .el-col-1 {
    text-align: center;
  }
  .el-input__inner {
    cursor: pointer;
    padding: 0 0.08rem 0 0.24rem !important;
    z-index: 1;
    height: 0.4rem;
  }
  .el-input__inner:focus {
    border-color: var(--themeGameHeader);
  }
  .el-form-item__label {
    padding-right: 0.24rem;
    font-size: 15px;
  }
  .query,
  .reset {
    width: 1.32rem;
    margin-left: 0.16rem;
    .el-button {
      width: 1.32rem;
      border-radius: 0.5rem;
      color: #ffffff;
      height: 0.32rem;
      font-size: 0.16rem;
      height: 0.4rem;
      border: 1px solid var(--themeColor);
    }
  }
  .querybgc .el-button {
    background-color: var(--themeColor);
  }
  .querybgc:hover .el-button {
    border: 1px solid var(--ButtonAction);
    background-color: var(--ButtonAction);
  }
  .reset {
    .el-button {
      color: var(--themeColor);
      border-color: var(--themeColor);
    }
  }
  .reset:hover .el-button {
    background-color: var(--themeWhite);
    border: 1px solid var(--ButtonAction);
  }

  .el-button--mini {
    font-size: 0.12rem;
  }
  .nothing {
    height: 3rem;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    .nothing-image {
      width: 3.48rem;
      margin-top: 0.1rem;
    }
    p {
      color: #999999;
      font-size: 0.12rem;
      font-family: PingFang-SC-Medium;
      margin-top: 0.23rem;
    }
  }
  .el-form-item {
    margin: 10px 0 10px 50px;
  }
  .remind {
    text-align: left;
    color: #ffab77;
    font-size: 0.125rem;
    margin-bottom: 0.21rem;
    margin-left: 50px;
  }

  .time-icon {
    position: relative;
    .el-icon-arrow-up:before {
      content: "";
    }
    .time-icon-right {
      pointer-events: none;
      position: absolute;
      right: 0.08rem;
      top: 50%;
      transform: translate(0, -50%);
      display: inline-block;
      //background: url("../../assets/images/icon-choose.png") no-repeat;
      background-size: 100%;
      width: 0.14rem;
      height: 0.12rem;
    }
  }
  .el-form-item__content {
    font-size: 12px;
  }
  .table-conent {
    height: 3rem;
  }

  .el-table__body-wrapper {
    max-height: 2.55rem !important;
    overflow-x: hidden !important;
  }
  .el-table__body-wrapper::-webkit-scrollbar {
    display: block;
    width: 8px;
    height: 8px;
    background-color: rgba(245, 245, 245, 0.47);
  }
  /*定义滚动条的轨道，内阴影及圆角*/
  .el-table__body-wrapper::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f4f4f4;
    border-radius: 10px;
    background-color: #f4f4f4;
  }

  /*定义滑块，内阴影及圆角*/
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*width: 10px;*/
    height: 20px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: var(--themeColor);
  }
  .btn{
      text-align: center;
      width: 60px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #e6e6e6;
      background-color: #f2f2f2;
      color: #4c4a4a;
      cursor: pointer;
      padding: 0;
  }
}
</style>
